(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) card.scrollIntoView({ behavior: 'instant' });
      },
      { once: true }
    );
  }
  document.addEventListener('DOMContentLoaded', function() {
    var filterBtn = document.querySelector('.avoir-toolbar__filter-btn');
    if (filterBtn) {
      filterBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        document.getElementById('va-mobile-sidebar').classList.add('open');
        document.getElementById('va-filter-overlay').classList.add('open');
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
